{
  "AUDIT_LOGS": {
    "HEADER": "Protokoly auditu",
    "HEADER_BTN_TXT": "Pridať protokoly auditu",
    "LOADING": "Načítavajú sa protokoly auditu",
    "DESCRIPTION": "Protokoly auditu uchovávajú záznam aktivít vo vašom účte, čo vám umožňuje sledovať a kontrolovať váš účet, tím alebo služby.",
    "LEARN_MORE": "Zistiť viac o protokoloch auditu",
    "SEARCH_404": "Neexistujú žiadne položky, ktoré by zodpovedali tejto požiadavke",
    "SIDEBAR_TXT": "<p><b>Protokoly auditu</b> </p><p> Protokoly auditu sú záznamy udalostí a akcií v systéme. </p>",
    "LIST": {
      "404": "V tomto účte nie sú dostupné žiadne protokoly auditu.",
      "TITLE": "Spravovať protokoly auditu",
      "DESC": "Protokoly auditu sú záznamy udalostí a akcií v systéme.",
      "TABLE_HEADER": {
        "ACTIVITY": "User",
        "TIME": "Action",
        "IP_ADDRESS": "IP adresa"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "Protokoly auditu boli úspešne načítané",
      "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
    },
    "DEFAULT_USER": "Systém",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} vytvoril(a) nové automatizačné pravidlo (#{id})",
      "EDIT": "{agentName} aktualizoval(a) automatizačné pravidlo (#{id})",
      "DELETE": "{agentName} odstránil(a) automatizačné pravidlo (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} pozval(a) {invitee} do účtu ako {role}",
      "EDIT": {
        "SELF": "{agentName} zmenil(a) svoje {attributes} na {values}",
        "OTHER": "{agentName} zmenil(a) {attributes} používateľa {user} na {values}",
        "DELETED": "{agentName} zmenil(a) {attributes} odstráneného používateľa na {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} vytvoril(a) novú schránku (#{id})",
      "EDIT": "{agentName} aktualizoval(a) schránku (#{id})",
      "DELETE": "{agentName} odstránil(a) schránku (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} vytvoril(a) nový webhook (#{id})",
      "EDIT": "{agentName} aktualizoval(a) webhook (#{id})",
      "DELETE": "{agentName} odstránil(a) webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} sa prihlásil(a)",
      "SIGN_OUT": "{agentName} sa odhlásil(a)"
    },
    "TEAM": {
      "ADD": "{agentName} vytvoril(a) nový tím (#{id})",
      "EDIT": "{agentName} aktualizoval(a) tím (#{id})",
      "DELETE": "{agentName} odstránil(a) tím (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} vytvoril(a) nové makro (#{id})",
      "EDIT": "{agentName} aktualizoval(a) makro (#{id})",
      "DELETE": "{agentName} odstránil(a) makro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} pridal(a) používateľa {user} do schránky (#{inbox_id})",
      "REMOVE": "{agentName} odstránil(a) používateľa {user} zo schránky (#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} pridal(a) používateľa {user} do tímu (#{team_id})",
      "REMOVE": "{agentName} odstránil(a) používateľa {user} z tímu (#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} aktualizoval(a) konfiguráciu účtu (#{id})"
    },
    "CONVERSATION": {
      "ADD": "{agentName} vytvoril konverzáciu (#{id})",
      "EDIT": "{agentName} aktualizoval konverzáciu (#{id}): {changes}"
    },
    "CONTACT": {
      "ADD": "{agentName} vytvoril kontakt (#{id})",
      "EDIT": "{agentName} aktualizoval kontakt (#{id}): {attributes}"
    }
  }
}
